export const HTTP_ERROR_MESSAGES: Record<number, string> = {
  400: 'Não conseguimos entender esse pedido. Tente novamente.',
  401: 'Você precisa entrar novamente para continuar.',
  403: 'Você não tem permissão para acessar isso.',
  404: 'Não encontramos o que você procurava.',
  409: 'Esse pedido conflita com algo que já existe. Revise e tente de novo.',
  422: 'Alguns dados enviados são inválidos. Revise e tente novamente.',
  429: 'Muitas tentativas em pouco tempo. Aguarde um instante e tente de novo.',
  500: 'Algo deu errado do nosso lado. Já estamos verificando.',
  502: 'Nosso servidor está temporariamente indisponível. Tente novamente em instantes.',
  503: 'O serviço está temporariamente fora do ar para manutenção.',
}

export const NETWORK_ERROR_MESSAGE =
  'Não foi possível conectar. Verifique sua internet e tente novamente.'

export const FALLBACK_ERROR_MESSAGE =
  'Algo inesperado aconteceu. Tente novamente em instantes.'

export function resolveHttpErrorMessage(statusCode: number): string {
  return HTTP_ERROR_MESSAGES[statusCode] ?? FALLBACK_ERROR_MESSAGE
}
